import Menu from "@/data/menu.json";

/** Rutas a las que cualquier usuario autenticado tiene acceso, sin importar su rol. */
export const RUTAS_LIBRES = ["/dashboard/mi-perfil", "/dashboard/mi-perfil/dispositivos", "/dashboard/cambiar-contraseña"];

/**
 * Opciones del menú que se pueden asignar a un rol, agrupadas por módulo.
 * Se generan desde menu.json, así que cualquier opción nueva del menú aparece automáticamente.
 * @returns {{ titulo: string, icono: string, opciones: { titulo: string, path: string }[] }[]}
 */
export function modulosConfigurables() {
  return (Menu.data || [])
    .map((item) => {
      if (item.type === "sub") {
        return {
          titulo: item.title,
          icono: item.icon,
          opciones: (item.children || [])
            .filter((c) => c.path)
            .map((c) => ({ titulo: c.title, path: c.path })),
        };
      }
      return { titulo: item.title, icono: item.icon, opciones: [{ titulo: item.title, path: item.path }] };
    })
    .filter((m) => m.opciones.length);
}

export function tieneAcceso(usuario, path) {
  if (RUTAS_LIBRES.includes(path)) return true;
  if (!usuario) return false;
  if (usuario.esAdmin) return true;
  return (usuario.permisos || []).includes(path);
}

/** Copia del menú solo con las opciones permitidas; los submenús sin opciones se omiten. */
export function filtrarMenu(items, usuario) {
  return items.reduce((acc, item) => {
    if (item.type === "sub") {
      const children = (item.children || []).filter((c) => tieneAcceso(usuario, c.path));
      if (children.length) acc.push({ ...item, active: false, children: children.map((c) => ({ ...c })) });
    } else if (tieneAcceso(usuario, item.path)) {
      acc.push({ ...item, active: false });
    }
    return acc;
  }, []);
}

/** Primera ruta del menú a la que el usuario tiene acceso (para redirigirlo si entra a una sin permiso). */
export function primeraRutaPermitida(usuario) {
  for (const modulo of modulosConfigurables()) {
    const opcion = modulo.opciones.find((o) => tieneAcceso(usuario, o.path));
    if (opcion) return opcion.path;
  }
  return RUTAS_LIBRES[0];
}
